import { useLocation } from "react-router-dom";
import NavMenu from "../../components/navbar/NavMenu";
import SchoolBusNavMenu from "../../components/createForm/SchoolBusNavMenu";
import TitleBar from "../../components/navbar/TitleBar";
import RoleMain from "../../components/role/RoleMain";
import Footer from "../../components/common/Footer";
import { Box } from "@mui/material";

export default function RolePage() {
  const location = useLocation();
  const isSchoolApp =
    localStorage.getItem("selectedApp") === "schoolTrack" ||
    location.pathname.startsWith("/school-users");
  const NavigationMenu = isSchoolApp ? SchoolBusNavMenu : NavMenu;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        justifyContent: "space-between",
      }}
    >
      <Box>
        <TitleBar />
        <NavigationMenu />
        <RoleMain />
      </Box>
      <Footer />
    </Box>
  );
}
